import { useEffect } from "react";

const RE = /pu(x)i/gi;

export const useRedX = () => {
  useEffect(() => {
    if (typeof window === "undefined" || !("Highlight" in window) || !CSS.highlights) return;
    const hl = new window.Highlight();
    CSS.highlights.set("puxi-x", hl);
    let raf = 0;
    const scan = () => {
      hl.clear();
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.nodeValue && /pux/i.test(n.nodeValue) && !["SCRIPT", "STYLE", "NOSCRIPT"].includes(n.parentElement?.tagName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
      });
      let n;
      while ((n = walker.nextNode())) {
        RE.lastIndex = 0;
        let m;
        while ((m = RE.exec(n.nodeValue))) {
          const r = new Range();
          r.setStart(n, m.index + 2);
          r.setEnd(n, m.index + 3);
          hl.add(r);
        }
      }
    };
    scan();
    const mo = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(scan);
    });
    mo.observe(document.body, { childList: true, characterData: true, subtree: true });
    return () => {
      mo.disconnect();
      cancelAnimationFrame(raf);
      CSS.highlights.delete("puxi-x");
    };
  }, []);
};
